import React from 'react'
import { TypeToInputType } from '../../variables/formBuilderData'
import inputComponents from '.'
import { getObject } from '../../utils/useful'

class TableDynamicInput extends React.Component {

    state = {
    }

    componentDidMount() {
        this.selectType()
    }

    componentDidUpdate(prevProps) {

        let info = this.props.header?.information

        if (info?.inputType != this.state.refInputType) {
            this.selectType()
        }
    }


    selectType = () => {

        let info = this.props.header?.information
        let inputType


        this.setState({ refInputType: info.inputType })


        if (info.helperField) {
            inputType = getObject(this.props.fullData, info.helperField)
        }


        this.setState({ inputType })

    }



    render() {
        // let styleInfo = this.props.styleInfo
        let Component = inputComponents[this.state.inputType]

        return (
            <div className="w-100 h-100 flexcc">
                {Component && (
                    <Component header={this.props.header} data={this.props.data} changeValue={this.changeValue} params={this.props.params} variables={this.props.variables} width={this.props.width} />
                )}
            </div>
        )
    }
}

export default TableDynamicInput;